import React, { FC } from "react";
import { IUserTrainingCourseSectionSummary } from "src/@types/ImpiricaPlatformApi";

type SpotlightrGalleryHtmlSectionProps = {
	section: IUserTrainingCourseSectionSummary;
};

export const SpotlightrGalleryHtmlSection: FC<
	SpotlightrGalleryHtmlSectionProps
> = ({ section }) => {
	return (
		<div data-testid="html-section">
			<h3>{section.name}</h3>
			<hr />
			{section.html && (
				<div dangerouslySetInnerHTML={{ __html: section.html }}></div>
			)}
		</div>
	);
};
